<template>
  <div>
    <Tooltip transfer v-if="partStock.warehouse_stocks">
        <a href="#">{{ partStock.quantity }}</a>
        <div slot="content">
          <Row style="width: 350px; font-weight:bold; font-size: 16px; margin-bottom: 5px;">
            <Col span="9">{{ partNumber}}</Col>
            <Col span="6" align="right">Sum: {{partStock.quantity}}</Col>
          </Row>
          <Row style="width: 350px;"
           v-for="(stock, index) in partStock.warehouse_stocks" :key="index">
            <Col span="9">{{stock.warehouse_id}} {{stock.warehouse_name}}:</Col>
            <Col span="6" align="right">{{stock.quantity}}</Col>
          </Row>
        </div>
    </Tooltip>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'StocksOverview',
  props: {
    partNumber: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      partStock: {}
    }
  },
  computed: {
    ...mapGetters([
      'erpStocks'
    ])
  },
  watch: {
    'erpStocks': {
      handler: function () {
        this.findAndSetStock()
      },
      deep: true
    },
    partNumber () {
      this.findAndSetStock()
    }
  },
  methods: {
    ...mapActions([
      'getErpStocks'
    ]),
    loadStocks (partNumbers) {
      this.getErpStocks({ part_numbers: partNumbers })
    },
    findAndSetStock() {
      this.partStock = _.get(this.erpStocks, this.partNumber, {})
      this.$emit('input', this.partStock.quantity || 0)
    }
  }
}
</script>
